import React from 'react';
import {authRoles} from 'app/auth';

export const KudeReciboHaberesPageConfig = {
    settings: {
        layout: {
            config: {
                navbar        : {
                    display: false
                },
                toolbar       : {
                    display: false
                },
                footer        : {
                    display: false
                },
                leftSidePanel : {
                    display: false
                },
                rightSidePanel: {
                    display: false
                }
            }
        }
    },
    auth    : authRoles.onlyGuest,
    routes  : [
        {
            path     : '/kuderecibohaberes/:id?',
            component: React.lazy(() => import('./KudeReciboHaberesPage'))
        }
    ]
};
